export const handleInputChange = setFormKeyValue => event => {
  const target = event.target;
  const value = target.type === "checkbox" ? target.checked : target.value;
  const key = target.name;

  setFormKeyValue(key, value);
};
